import * as React from 'react';
import { compose, withProps, withHandlers, withPropsOnChange } from 'recompose';
import AppBar from '@material-ui/core/AppBar';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import Toolbar from '@material-ui/core/Toolbar';
import { Link } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import { get } from 'lodash';
import PeopleIcon from '@material-ui/icons/People';
import AddIcon from '@material-ui/icons/PersonAdd';
import MenuIcon from '@material-ui/icons/Menu';
import MenuIconMini from '@material-ui/icons/DragHandle';
import PersonIcon from '@material-ui/icons/Person';
import AssignmentIcon from '@material-ui/icons/Assignment';
import HomeIcon from '@material-ui/icons/Home';
import ExitIcon from '@material-ui/icons/ExitToApp';
import IconButton from '@material-ui/core/IconButton';
import withLoader from '../../modules/app/withLoader';

const ls = window.localStorage;

const styles = (theme) => ({
  '@global': {
    body: {
      backgroundColor: theme.palette.common.white,
    },
  },
  appBar: {
    position: 'fixed',
  },
  toolbar: {
    justifyContent: 'space-between',
  },
  button: {
    marginLeft: 5,
  },
  addPersonButton: {
    marginLeft: 0,
    minWidth: 0,
  },
  personButton: {
    marginRight: 0,
    background: '#fb0',
  },
});

const enhance = compose(
  withStyles(styles),
  withRouter,
  withLoader,
  withProps(({ location }) => {
    return {
      activeUrl: get(location, 'pathname', null)
        ? get(location, 'pathname', null).split('/')[1]
        : null,
    };
  }),
  connect(
    (state) => ({
      isMiniMode: get(state, 'app.miniMode', false),
    }),
    null
  ),
  withHandlers({
    NavButton:
      ({ activeUrl, classes }) =>
      ({ url, label, Icon = undefined, className = '' }) => {
        const isActive = activeUrl === url;
        return (
          <Button
            variant={isActive ? 'raised' : 'outlined'}
            component={(props) => <Link to={`/${url}`} {...props} />}
            className={`${classes.button} ${className}`}
            color={isActive ? 'secondary' : 'default'}
            size="small"
          >
            {Icon ? <Icon style={{ marginRight: 4, width: 20, height: 20 }} /> : null}
            {label}
          </Button>
        );
      },
    toggleMiniMode:
      ({ toggleMiniMode, isMiniMode }) =>
      () => {
        ls.setItem('miniMode', !isMiniMode);
        toggleMiniMode(!isMiniMode);
        document.body.classList.toggle('is-mini-mode');
      },
  }),
  withPropsOnChange([], ({ classes }) => ({
    leftButtons: [
      { url: 'users', label: 'Zákazníci', Icon: PeopleIcon, className: classes.personButton },
      { url: 'reservations', label: 'Rezervace', Icon: AssignmentIcon },
    ],
    rightButtons: [
      { url: 'attributes', label: 'Atributy' },
      { url: 'categories', label: 'Kategorie' },
      { url: 'products', label: 'Produkty' },
      { url: 'items', label: 'Zboží' },
      { url: 'services', label: 'Služby' },
      { url: 'prices', label: 'Ceník' },
      { url: 'account', label: 'Účet', Icon: PersonIcon },
    ],
  }))
);

export default enhance(
  ({
    classes,
    loading,
    logout,
    activeUrl,
    NavButton,
    leftButtons,
    rightButtons,
    history,
    toggleMiniMode,
    isMiniMode,
  }) => (
    <AppBar position="fixed" color="default" className={classes.appBar}>
      <Toolbar
        className={classes.toolbar}
        variant={isMiniMode ? 'dense' : 'regular'}
        style={isMiniMode ? { minHeight: 38, paddingLeft: 6, paddingRight: 6 } : {}}
      >
        <div>
          <IconButton style={isMiniMode ? { padding: 6 } : {}} onClick={toggleMiniMode}>
            {isMiniMode ? <MenuIconMini /> : <MenuIcon />}
          </IconButton>
          <IconButton style={isMiniMode ? { padding: 6 } : {}} onClick={() => history.push('/')}>
            <HomeIcon />
          </IconButton>
          {leftButtons.map((button) => (
            <React.Fragment key={button.url}>
              <NavButton {...button} />
              {button.url === 'users' ? (
                <NavButton
                  {...{
                    url: 'users/add',
                    label: ' ',
                    Icon: AddIcon,
                    className: classes.addPersonButton,
                  }}
                />
              ) : null}
            </React.Fragment>
          ))}
        </div>
        <div>
          {rightButtons.map((button) => (
            <NavButton key={button.url} {...button} />
          ))}
          <Button
            variant="outlined"
            className={classes.button}
            onClick={() => logout()}
            size="small"
          >
            <ExitIcon style={{ width: 20, height: 20 }} />
            &nbsp;Odhlásit
          </Button>
        </div>
      </Toolbar>
    </AppBar>
  )
);



// WEBPACK FOOTER //
// ./src/components/appBar/index.js